import type { ReactNode } from 'react';
import { AppShell } from './AppShell/AppShell';
import styles from './ErrorView.module.css';

interface Props {
  message: string;
  status?: number;
  title?: string;
  /** Optionale Aktion unter der Meldung (z. B. Retry). */
  action?: ReactNode;
}

export function ErrorView({ message, status, title = 'Something went wrong', action }: Props) {
  return (
    <AppShell variant="logo-only">
      <main className={styles.wrap}>
        <div className={styles.card}>
          <i
            className={`ph-fill ph-warning-octagon ${styles.icon}`}
            aria-hidden="true"
          />
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.message}>{message}</p>
          {status !== undefined && (
            <div className={styles.code}>HTTP {status}</div>
          )}
          {action && <div className={styles.action}>{action}</div>}
        </div>
      </main>
    </AppShell>
  );
}
